'use client';

import Image from '@src/components/atoms/safe-image';

import Modal from '@src/components/modal'
import Button from '@src/components/century-21-or-company/button';

import CheckIcon from "@public/png/check-1.png";
import XIcon from '@public/png/x-1.png';

const ModalSuccess = ({ title, description, onClose, ...props }) => {
  return (
    <Modal {...props} onClose={onClose}>
      <div className='px-6 py-4 flex flex-col items-center z-[42px] w-[360px] rounded-2xl bg-white-3'>
        <div className='w-full flex justify-end'>
          <Image
            width={16}
            height={16}
            src={XIcon}
            alt='Close'
            className='cursor-pointer object-contain'
            onClick={onClose}
          />
        </div>
        <div className='bg-green-0 mb-6 flex items-center justify-center p-4 rounded-[200px]'>
          <Image
            width={40}
            height={40}
            src={CheckIcon}
            alt='Success'
            className='object-contain'
          />
        </div>

        <p className='text-22 font-sfpro-bold text-center'>{title}</p>
        <p className='text-12 text-grey-1 text-center mb-4'>{description}</p>
        <Button text="OKE" onClick={onClose} />
      </div>
    </Modal>
  )
}

export default ModalSuccess